function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#288b94;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logoLista");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M80.26,8.48A4.09,4.09,0,0,0,76,4.18c-9.58.08-19.15,0-28.73,0q-16.89,0-33.77,0a5.15,5.15,0,0,0-1.93.42A4,4,0,0,0,9.49,7.27v45.6a4,4,0,0,0,4.06,3.06H76.19a5.06,5.06,0,0,0,1.1-.09,3.81,3.81,0,0,0,2.95-4C80.24,37.4,80.21,22.94,80.26,8.48Zm-1.94,33.4c0,3.31,0,6.63,0,9.94,0,1.5-.69,2.19-2.2,2.19H13.6c-1.5,0-2.18-.7-2.18-2.21q0-4.94,0-9.88v-.69H78.32ZM11.41,39.25V8.43c0-1.64.66-2.3,2.3-2.3H76c1.64,0,2.29.66,2.29,2.3q0,15,0,30v.83Z",
  transform: "translate(-9.49 -4.18)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.5,22.13c-3.58-2.08-7.16-4.14-10.74-6.21C39.62,15.27,39,15.66,39,17v6.07c0,2.12,0,4.24,0,6.35,0,1.1.7,1.5,1.65,1q5.45-3.12,10.87-6.26C52.52,23.51,52.52,22.72,51.5,22.13ZM40.92,28V18.23l8.46,4.88Z",
  transform: "translate(-9.49 -4.18)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.25,48.53a3,3,0,0,0,.68,0h12a.77.77,0,0,1,.89.59,4.23,4.23,0,0,0,5.88,2.28,4.4,4.4,0,0,0,2.28-2.86H69.66a3.81,3.81,0,0,0,.76,0,.95.95,0,0,0,0-1.88,5.27,5.27,0,0,0-.69,0H41c-.69-2-2-3.27-4.15-3.3s-3.57,1.22-4.28,3.3H20a4.26,4.26,0,0,0-.62,0,.91.91,0,0,0-.86.93A.9.9,0,0,0,19.25,48.53Zm17.51-3.28a2.36,2.36,0,0,1,0,4.71,2.36,2.36,0,1,1,0-4.71Z",
  transform: "translate(-9.49 -4.18)"
});

var SvgLogoLista = function SvgLogoLista(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 70.77 51.75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoLista, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoLista.a37d015d.svg";
export { ForwardRef as ReactComponent };